import styled from 'styled-components'

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${(props) => (props.theme.isMobile ? '4rem 1rem' : '2rem')};
  width: 100%;
`

export const Header = styled.div`
  padding: 1rem 0;
  color: ${(props) => props.theme.colors.white};
  font-size: ${(props) => props.theme.sizes.h1};
  font-weight: 700;
  & span {
    font-weight: 300;
  }
`

export const Wrapper = styled.div<{ flex?: string }>`
  display: ${(props) => (props.theme.isMobile ? 'initial' : 'flex')};
  flex-direction: ${(props) => (props.theme.isMobile ? 'column' : 'row')};
  flex: ${(props) => (props.flex ? props.flex : '1')};
`

export const ContentWrapper = styled.div<{ flex?: string }>`
  display: ${(props) => (props.theme.isMobile ? 'initial' : 'flex')};
  flex-direction: ${(props) => (props.theme.isMobile ? 'column' : 'row')};
  row-gap: ${(props) => props.theme.isMobile && '1rem'};
  column-gap: ${(props) => !props.theme.isMobile && '1rem'};
`

export const ColumnWrapper = styled.div`
  display: ${(props) => (props.theme.isMobile ? 'initial' : 'flex')};
  flex-direction: column;
  flex: 1;
`

export const CenterWrapper = styled.div`
  flex: 1;
  display: ${(props) => (props.theme.isMobile ? 'initial' : 'flex')};
  align-items: center;
  justify-content: center;
  height: 100%;
  & p {
    padding: 0.5rem;
  }
`
export const ButtonBase = styled.a`
  padding: 0.5rem;
  border: none;
  outline: none;
  background-color: ${(props) => props.theme.colors.whiteAlpha10};
  color: ${(props) => props.theme.colors.white};
  cursor: pointer;
  flex: 1;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  transition: ease-in-out 0.2s;
  border-radius: 4px;
  &:hover {
    transition: ease-in-out 0.2s;
    background-color: ${(props) => props.theme.colors.primaryColor500};
    color: ${(props) => props.theme.colors.primaryColor700};
  }
`

export const ImgWrapper = styled.div<{ profilepic: string }>`
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 10rem;
  height: 10rem;
  border-radius: 50%;
  background-image: url(${(props) => props.profilepic});
  background-size: cover;
`

export const Card = styled.div`
  display: flex;
  flex: 1;
  padding: 1rem;
  flex-direction: column;
  border-radius: 4px;
  background: ${(props) => props.theme.gradient.cardBackground};
  box-shadow: ${(props) => props.theme.shadow.main};
`

export const CardTitle = styled.div`
  padding: ${(props) => (props.theme.isMobile ? '0.5rem' : '0.5rem 1rem')};
  font-weight: 700;
  font-size: ${(props) => (props.theme.isMobile ? props.theme.sizes.h4 : props.theme.sizes.h2)};
`

export const CardContent = styled.div`
  column-gap: 1rem;
  padding: ${(props) => (props.theme.isMobile ? '0.5rem' : '0.5rem 1rem')};
  display: flex;
  flex: 1;
`

export const TextData = styled.div<{ size: string; fontWeight?: number | string }>`
  font-size: ${(props) => props.theme.sizes[props.size as keyof typeof props.theme.sizes]};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 'unset')};
  padding: 0.5rem 0;
`

export const CardFooter = styled.div`
  display: flex;
  border-top: 1px solid ${(props) => props.theme.colors.whiteAlpha10};
`

export const DescriptionInfos = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`

export const DescriptionInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${(props) => (props.theme.isMobile ? '0.5rem' : '1rem')};
  font-size: ${(props) => (props.theme.isMobile ? props.theme.sizes.h6 : props.theme.sizes.h4)};
  & div:first-child {
    color: ${(props) => props.theme.colors.whiteAlpha40};
  }
`
